/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../helpers';
import { PageStateContext } from '../../../../services';
import { Props } from '../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const OldLayout = ({ blok, getComponent }: PageProps) => {
  const pageContext = useContext(PageStateContext);
  const globalSettings = pageContext?.settings;

  const releaseDate = {
    _uid: `${blok._uid}-release-date`,
    component: 'roche-date',
    date: blok.release_date,
    show_icon: true,
  };

  const headline = {
    _uid: `${blok._uid}-headline`,
    component: 'roche-headline',
    headline: blok.headline,
  };

  const subline = {
    _uid: `${blok._uid}-subline`,
    component: 'roche-richtext',
    text: blok.subline,
  };

  const introText = {
    _uid: `${blok._uid}-intro-text`,
    component: 'roche-richtext',
    text: blok.intro_text,
  };

  const content = [
    headline,
    subline,
    introText,
    ...blok.content || [],
  ];

  const contentAside = [
    ...blok.contact_list || [],
    ...blok.content_aside || [],
  ];

  const tags = [{
    _uid: `${blok._uid}-tags`,
    component: 'roche-tags',
    tags: blok.tags,
  }];

  const overviewLink = {
    _uid: `${blok._uid}-overview-link`,
    component: 'roche-internal-link',
    text: globalSettings?.press_articles_overview_link_label,
    url: `/${globalSettings?.press_articles_overview_link_url?.story?.fullSlug}`,
    icon: 'chevron-left',
  };

  return (
    <>
      {blok.release_date && blokToComponent({
        blok: {
          _uid: `${blok._uid}-grid-1`,
          component: 'roche-grid-12',
          slotted: [releaseDate],
        },
        getComponent,
      })}

      {blokToComponent({
        blok: {
          _uid: `${blok._uid}-grid-2`,
          component: 'roche-grid-8-4',
          slotted_left: content,
          slotted_right: contentAside,
        },
        getComponent,
      })}

      {blokToComponent({
        blok: {
          _uid: `${blok._uid}-grid-3`,
          component: 'roche-grid-8-4',
          slotted_left: [...tags, overviewLink],
        },
        getComponent,
      })}

      {blok.further_content && blokToComponent({
        blok: {
          _uid: `${blok._uid}-grid-4`,
          component: 'roche-grid-12',
          slotted: blok.further_content,
        },
        getComponent,
      })}
    </>
  );
};
